import * as React from 'react';
import { DeviceType } from '../../shared/types/ast';

type Props = {
    id: string;
    deviceType: DeviceType;
};

export function AdSenseForShopping(props: Props) {
    const { id = 'afshcontainer', deviceType } = props;

    const style = {
        border: '0',
        padding: '0px',
        marginTop: deviceType === 'mobile' ? '8px' : '2px',
    };

    return (
        <div id={id} className="ads__unit" style={style} aria-hidden="true" />
    );
}
